<template>
  <v-navigation-drawer
    persistent
    :temporary="permanent ? false : true"
    :mini-variant="false"
    :clipped="false"
    v-model="drawer"
    enable-resize-watcher
    fixed
    app
    right
  >
    <div>
      <v-list subheader two-line>
        <v-tooltip>
          <v-subheader
            slot="activator"
          >{{$route.name == 'email' ? 'Sub-Contractor Options' :'Filters and Settings'}}</v-subheader>
          <span>
            {{$route.name == 'email' ?
            'Here you can quickly add Sub-Contractors who have worked on projects or sites in selected billing periods' :
            'These settings filter the data that is returned from the server. This data can be sorted through from the filters on the main page.'}}
          </span>
        </v-tooltip>

        <v-list-tile v-if="showProject">
          <v-list-tile-action>
            <v-icon>{{$store.state.global.pages.project.icon}}</v-icon>
          </v-list-tile-action>
          <v-autocomplete
            label="Project"
            color="indigo"
            :items="projects"
            item-text="name"
            item-value="id"
            v-model="projectId"
            :loading="loadingProjects"
            clearable
            @click:clear="() => $nextTick(() => projectId = null)"
          ></v-autocomplete>
        </v-list-tile>
        <v-list-tile v-if="showSite">
          <v-list-tile-action>
            <v-icon>{{$store.state.global.pages.site.icon}}</v-icon>
          </v-list-tile-action>
          <v-autocomplete
            label="Site"
            color="indigo"
            :items="filteredSites"
            item-text="name"
            item-value="id"
            v-model="siteId"
            :loading="loadingSites"
            clearable
            @click:clear="() => $nextTick(() => siteId = null)"
          ></v-autocomplete>
        </v-list-tile>

        <v-list-tile v-if="showUsers">
          <v-list-tile-action>
            <v-icon>{{$store.state.global.pages.user.icon}}</v-icon>
          </v-list-tile-action>
          <v-autocomplete
            label="Entered By"
            color="indigo"
            :items="users"
            item-text="name"
            item-value="id"
            v-model="selectedUserId"
            clearable
            @click:clear="() => $nextTick(() => selectedUserId = null)"
          ></v-autocomplete>
        </v-list-tile>
        <v-list-tile v-if="showBillingPeriod">
          <v-list-tile-action>
            <v-icon>calendar_today</v-icon>
          </v-list-tile-action>
          <v-autocomplete
            label="Billing Period"
            color="indigo"
            :items="allBillingPeriods"
            v-model="billingPeriod"
            :clearable="$route.name == 'docket' || $route.name == 'email' || $route.name == 'rcti' || $route.name == 'billing' || $route.name == 'approvedBillLine'"
            @click:clear="() => $nextTick(() => billingPeriod = null)"
          ></v-autocomplete>
        </v-list-tile>
        <v-list-tile v-if="showBillingStatus">
          <v-list-tile-action>
            <v-icon>account_balance</v-icon>
          </v-list-tile-action>
          <v-autocomplete
            label="Billing Status"
            color="indigo"
            :items="['Balanced', 'Outstanding']"
            v-model="billingStatus"
            clearable
            @click:clear="() => $nextTick(() => billingStatus = null)"
          ></v-autocomplete>
        </v-list-tile>
        <v-list-tile v-if="$route.name == 'email'">
          <v-btn
            block
            :color="$store.state.global.pages.email.color"
            depressed
            @click="$emit('addToEmail')"
          >Add To Email</v-btn>
        </v-list-tile>
        <v-list-tile v-if="showShowClosed" @click="emptyFunc">
          <v-list-tile-action>
            <v-switch :color="$store.state.global.pages.docket.color" v-model="showClosed"></v-switch>
          </v-list-tile-action>
          <v-list-tile-content @click="showClosed = !showClosed">
            <v-list-tile-title class="body-2">Show Closed</v-list-tile-title>
            <v-list-tile-sub-title>{{showClosed ? 'Yes!' : 'No'}}</v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile v-if="$route.name == 'allocation'" @click="emptyFunc">
          <v-list-tile-action>
            <v-switch :color="$store.state.global.pages.docket.color" v-model="showVoid"></v-switch>
          </v-list-tile-action>
          <v-list-tile-content @click="showVoid = !showVoid">
            <v-list-tile-title class="body-2">Show VOID</v-list-tile-title>
            <v-list-tile-sub-title>{{showVoid ? 'Yes!' : 'No'}}</v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile v-if="$route.name == 'rate'" @click="emptyFunc">
          <v-list-tile-action>
            <v-switch :color="$store.state.global.pages.rate.color" v-model="showInactive"></v-switch>
          </v-list-tile-action>
          <v-list-tile-content @click="showInactive = !showInactive">
            <v-list-tile-title class="body-2">Show Inactive</v-list-tile-title>
            <v-list-tile-sub-title>{{showInactive ? 'Yes!' : 'No'}}</v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile v-if="!!$route.query.ids" @click="emptyFunc">
          <v-list-tile-action>
            <v-switch :color="$store.state.global.pages.docket.color" v-model="showCreated"></v-switch>
          </v-list-tile-action>
          <v-list-tile-content @click="showCreated = !showCreated">
            <v-list-tile-title class="body-2">Show Only Newly Created</v-list-tile-title>
            <v-list-tile-sub-title>{{showCreated ? 'Yes!' : 'No'}}</v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>

        <template v-if="showDateRange">
          <v-subheader>Date Range</v-subheader>
          <v-list-tile>
            <v-list-tile-action>
              <v-icon>date_range</v-icon>
            </v-list-tile-action>
            <date-picker-wrapper
              label="Start"
              noIcon
              style="width: 100%"
              v-model="dateRangeStart"
              :rules="[]"
            ></date-picker-wrapper>
          </v-list-tile>

          <v-list-tile v-if="!useSingleDate">
            <v-list-tile-action>
              <v-icon>date_range</v-icon>
            </v-list-tile-action>
            <date-picker-wrapper
              label="End"
              noIcon
              style="width: 100%"
              v-model="dateRangeEnd"
              :rules="[]"
            ></date-picker-wrapper>
          </v-list-tile>

          <v-list-tile @click="emptyFunc">
            <v-list-tile-action>
              <v-switch :color="$store.state.global.pages.docket.color" v-model="useSingleDate"></v-switch>
            </v-list-tile-action>
            <v-list-tile-content @click="toggleSingleDate">
              <v-list-tile-title class="body-2">Single Date</v-list-tile-title>
              <v-list-tile-sub-title>{{useSingleDate ? 'Yes!' : 'No'}}</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </template>

        <v-list-tile v-if="showDateRangeToggle" @click="emptyFunc">
          <v-list-tile-action>
            <v-switch color="primary" v-model="dateRangeToggle"></v-switch>
          </v-list-tile-action>
          <v-list-tile-content @click="dateRangeToggle = !dateRangeToggle">
            <v-list-tile-title class="body-2">Use Created At Date</v-list-tile-title>
            <v-list-tile-sub-title>{{dateRangeToggle ? 'Using Created At Date' : 'Using Date'}}</v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </div>
  </v-navigation-drawer>
</template>

<script>
import Store from '@/store/computed/storeHelpers'
import BillingPeriods from '@/services/mixins/billingPeriods'
import RouteProps from '@/services/mixins/routeProps'
import getProjects from '@/services/mixins/getMasterFiles/getProjects'
import getSites from '@/services/mixins/getMasterFiles/getSites'
import filterProjectSites from '@/services/mixins/filterProjectSites'
import getUsers from '@/services/mixins/getMasterFiles/getUsers'

import DatePickerWrapper from '@/components/ui/datePickerWrapper'
export default {
  mixins: [
    RouteProps,
    BillingPeriods,
    getProjects,
    getSites,
    getUsers,
    filterProjectSites
  ],
  components: {
    DatePickerWrapper
  },
  data() {
    return {
      advancedSearchDialog: false
    }
  },
  methods: {
    emptyFunc() {
      return
    },
    toggleSingleDate() {
      this.useSingleDate = !this.useSingleDate
    }
  },
  computed: {
    showVoid: Store.getSet({ store: 'allocations', prop: 'showVoid' }),
    showClosed: Store.getSet({ store: 'shared', prop: 'showClosed' }),
    drawer: Store.getSet({ store: 'shared', prop: 'drawer' }),
    billingPeriod: Store.getSet({ store: 'shared', prop: 'billingPeriod' }),
    billingStatus: Store.getSet({ store: 'shared', prop: 'billingStatus' }),
    projectId: Store.getSet({ store: 'shared', prop: 'projectId' }),
    siteId: Store.getSet({ store: 'shared', prop: 'siteId' }),
    selectedUserId: Store.getSet({ store: 'shared', prop: 'selectedUserId' }),
    showCreated: Store.getSet({ store: 'shared', prop: 'showCreated' }),
    showInactive: Store.getSet({ store: 'shared', prop: 'showInactive' }),
    dateRangeStart: Store.getSet({ store: 'shared', prop: 'dateRangeStart' }),
    dateRangeEnd: Store.getSet({ store: 'shared', prop: 'dateRangeEnd' }),
    dateRangeToggle: Store.getSet({ store: 'shared', prop: 'dateRangeToggle' }),
    useSingleDate: Store.getSet({ store: 'shared', prop: 'useSingleDate' }),
    //users: Store.getSet({store: 'users', prop: 'users'}),
    showProject() {
      if (this.$route.name != 'rcti' && this.$route.name != 'billing') {
        return true
      } else {
        return false
      }
    },
    showSite() {
      if (
        this.$route.name == 'docket' ||
        this.$route.name == 'allocation' ||
        this.$route.name == 'allocationStaging' ||
        this.$route.name == 'email' ||
        this.$route.name == 'approvedBillLine'
      ) {
        return true
      } else {
        return false
      }
    },
    showBillingPeriod() {
      if (
        this.$route.name != 'rate' &&
        this.$route.name != 'allocationStaging' &&
        this.$route.name != 'allocation' &&
        this.$route.name != 'tipping'
      ) {
        return true
      } else {
        return false
      }
    },
    showShowClosed() {
      if (
        this.$route.name == 'docket' ||
        this.$route.name == 'approvedBillLine' ||
        this.$route.name == 'allocation' ||
        this.$route.name == 'allocationStaging' ||
        this.$route.name == 'tipping'
      ) {
        return true
      } else {
        return false
      }
    },
    showUsers() {
      if (
        this.$route.name == 'docket' ||
        this.$route.name == 'allocationStaging' ||
        this.$route.name == 'allocation' ||
        this.$route.name == 'tipping' ||
        this.$route.name == 'approvedBillLine'
      ) {
        return true
      } else {
        return false
      }
    },
    showDateRange() {
      if (
        this.$route.name == 'allocationStaging' ||
        this.$route.name == 'allocation' ||
        this.$route.name == 'tipping' ||
        this.$route.name == 'docket' ||
        this.$route.name == 'approvedBillLine'
      ) {
        return true
      } else {
        return false
      }
    },
    showDateRangeToggle() {
      if (this.$route.name == 'tipping') {
        return true
      } else {
        return false
      }
    },
    showBillingStatus() {
      return (
        this.$route.name == 'approvedBillLine' || this.$route.name == 'docket'
      )
    }
  },
  watch: {
    useSingleDate(val) {
      if (val) {
        this.dateRangeEnd = this.dateRangeStart
      } else {
        this.dateRangeEnd = null
      }
    },
    dateRangeStart(val) {
      if (this.useSingleDate) {
        this.dateRangeEnd = val
      }
    }
  },
  props: {
    permanent: Boolean
  }
}
</script>

<style>
.overlap-fab {
  position: absolute !important;
  bottom: -33px;
  right: 20px;
}
</style>
